export enum DisputeReason {
  PRODUCT_NOT_RECEIVED = 'PRODUCT_NOT_RECEIVED',
  PRODUCT_NOT_AS_DESCRIBED = 'PRODUCT_NOT_AS_DESCRIBED',
  PRODUCT_WAS_FAULTY = 'PRODUCT_WAS_FAULTY',
  OTHER = 'OTHER',
}

export const DISPUTE_REASON_OPTIONS = [
  {
    value: DisputeReason.PRODUCT_NOT_RECEIVED,
    label: 'Goods not received',
    id: 1,
  },
  {
    value: DisputeReason.PRODUCT_NOT_AS_DESCRIBED,
    label: 'Goods/services not as described',
    id: 2,
  },
  {
    value: DisputeReason.PRODUCT_WAS_FAULTY,
    label: 'Faulty or damage goods/services',
    id: 3,
  },
  {
    value: DisputeReason.OTHER,
    label: 'Other',
    id: 4,
  },
] as const
